
import {Contact} from './contact';
import {BankDetails} from './bank';
import {Pricing} from "./prcing";
import {EquipmentOffer} from "./equipment_offer";

export class Outlet {
    constructor(outlet) {
        this.section = '';
        this.save_change = '';
        this.application_external_id = '';
        this.outlet_external_id = '';
        this.payment_face_to_face = '';
        this.payment_online = '';
        this.payment_online = '';
        this.business_trading_name = '';
        this.trade_name = '';
        this.store_number = '';
        this.business_zone = '';
        this.business_location = '';
        this.ground_floor = '';
        this.number_of_building_floors = '';
        this.square_foot_count = '';
        this.number_of_employees = '';
        this.primary_email_address = '';
        this.banking_window = '';
        this.hotel_no = '';
        this.seneca_cust_no = '';
        this.tenant_parent_mid_id  = '';
        this.client_region_external_id  = '';
        this.client_region  = '';
        this.outlet_website = '';
        this.store_contact_same_as_main_principal = '';
        this.store_alt_contact_same_as_main_principal = '';
        this.store_address_same_as_registered_address = '';
        this.store_contact_same_as_business_contact = '';
        this.store_alt_address_same_as_registered_address = '';
        this.store_alt_address_same_as_trading_address = '';
        this.technical_contact_same_as_main_principal = '';
        this.technical_contact_same_as_store_address = '';
        this.delivery_contact_title = '';
        this.delivery_contact_first_name = '';
        this.delivery_contact_last_name = '';
        this.delivery_contact_phone_code = '';
        this.delivery_contact_phone_no = '';
        this.delivery_email_address = '';
        this.trading_name_same_as_legal_name = '';
        this.shipping_address_same_as_trading_address = '';
        this.shipping_address_same_as_registered_address = '';
        this.billing_address_same_as_trading_address = '';
        this.billing_address_same_as_registered_address = '';
        this.technical_address_same_as_registered_address = '';
        this.technical_address_same_as_trading_address = '';
        this.mcc_iso = '';
        this.like_for_like = '';
        this.curr_code = '';
        this.auto_renewal_flag = '';
        this.seasonal_business = '';
        this.seasonal_months = '';
        this.prod_serv_sold = '';
        this.chain_number = '';
        this.cvv2_used = '';
        this.deposit_flag = '0';
        this.deposit_req_perc = '';
        this.deposit_avg_time = '';
        this.ent_amex_entitlement_required = '';
        this.ent_amex_merchant_type = '';
        this.third_party_merch_id = '';
        this.amex_agreement_code = '';
        this.amex_industry_code = '';
        this.amex_net_discount_rate = '';
        this.amex_gross_discount_rate = '';
        this.annual_turnover = '';
        this.annual_card_turnover = '';
        this.avg_ticket_sales_amt = '';
        this.highest_ticket_sales_amt = '';
        this.stock_held_value = '';
        this.projected_12_months_moto_and_ecom_trans = '';
        this.has_full_pmnt_bef_del = '';
        this.delivery_timeframe = '0';
        this.perc_annual_upfront_of_turnover = '0';
        this.mastercard_sales = '';
        this.visa_sales = '';
        this.visa_mastercard_sales = '';
        this.telecheck_annual_volume = '';
        this.voyager_annual_volume = '';
        this.discover_service_type = '';
        this.existing_discover_se = '';
        this.discover_volume = '';
        this.amex_type = '';
        this.statement_type = '';
        this.statement_delivery_method = '';
        this.chargeback_retrievals_mail = '';
        this.funding_cut = '';
        this.clearing_bank = '';
        this.clearing_effective_date = '';
        this.funding_bank = '';
        this.funding_effective_date = '';
        this.existing_amex_se = '';
        this.amex_volume = '';
        this.ebt_se_number = '';
        this.eca_verification_number = '';
        this.valuelink_number = '';
        this.valuelink_alt_number = '';
        this.debit_se_number = '';
        this.fns_number = '';
        this.refund_days = '';
        this.refund_policy = '';
        this.third_party_payment = '';
        this.third_party_names = '';
        this.sales_keyed_perc = 0;
        this.sales_ftf_perc = 0;
        this.sales_moto_perc = 0;
        this.sales_mail_perc = 0;
        this.sales_phone_perc = 0;
        this.sales_tradeshow_perc = 0;
        this.sales_internet_perc = 0;
        this.sales_recurring_flag = '';
        this.recurring_flag = '';
        this.deposit_balance_settle_time = '';
        this.deposit_avg_time = '';
        this.transaction_process_mode = '';
        this.chip_flag = '';
        this.average_delivery_days = '';
        this.delivery_0_days_perc = '';
        this.delivery_1_to_7_days_perc = '';
        this.delivery_8_to_14_days_perc = '';
        this.delivery_15_to_30_days_perc = '';
        this.delivery_over_30_days_perc = '';
        this.membership_card_applicable = '';
        this.membership_card_turnover = '';
        this.membership_card_avg_percent = '';
        this.membership_card_avg_duration = '';
        this.moto_ecom_guarantee = '';
        this.moto_ecom_delivery_method = '';
        this.contacts = [];
        this.banks = [];
        this.charges = {};
        this.equipment_offer = {};
        this.trading = new Contact().setContactType('OT');  //trading refers to the store
        this.alt_trading = new Contact().setContactType('OTALT');
        //this.store_contact = new Contact().setContactType('ST');
        this.shipping = new Contact().setContactType('S');
        this.billing = new Contact().setContactType('B');
        this.technical = new Contact().setContactType('T');
        this.legal = new Contact().setContactType('L');
        this.ecom_payment_methods = {
            selected_standard_methods:[],
            standard_methods_data:[],
            selected_pro_methods:[],
            pro_methods_data: [],
            option_methods_data: []
        };
        if(!!outlet) {
            this.setOutlet(outlet);
        }
    }

    setContactTypes() {
        const outlet =  this;
        Object.keys(outlet.contacts).forEach(function (contact_key){
            if(outlet.contacts[contact_key].contact_type == 'OT') {
                outlet.trading = new Contact({...outlet.contacts[contact_key], _id: contact_key});
            } else if(outlet.contacts[contact_key].contact_type == 'OTALT') {
                outlet.alt_trading = new Contact({...outlet.contacts[contact_key], _id: contact_key});
            }  else if(outlet.contacts[contact_key].contact_type == 'S') {
                outlet.shipping = new Contact({...outlet.contacts[contact_key], _id: contact_key});
            } else if(outlet.contacts[contact_key].contact_type == 'B') {
                outlet.billing = new Contact({...outlet.contacts[contact_key], _id: contact_key});
            } else if(outlet.contacts[contact_key].contact_type == 'T') {
                outlet.technical = new Contact({...outlet.contacts[contact_key], _id: contact_key});
            } else if(outlet.contacts[contact_key].contact_type == 'L') {
                outlet.legal = new Contact({...outlet.contacts[contact_key], _id: contact_key});
            }
        })
    }

    setOutlet(outlet) {
        let outlet_keys = Object.keys(outlet);
        const vm =  this;
        outlet_keys.map((f) => {
            if(f === 'banks') {
                if(!!outlet.banks) {
                    Object.values(outlet.banks).forEach(function (bank){
                        vm.banks.push(new BankDetails(bank))
                    });
                }
            } else if(f == 'charges') {
                vm[f] = new Pricing(outlet[f]);
            } else if(f == 'equipment_offer') {
                vm[f] = new EquipmentOffer(outlet[f]);
            }
            else if (f == 'deposit_flag'){
                vm[f] = !!outlet[f] ? outlet[f] : vm[f];
            }
            else {
                vm[f] = outlet[f]
            }
        });

        this.setContactTypes();
    }

    setClientReqionText() {
        this.client_region = '[' + this.client_region_external_id + ']';
        // create a property that hold the text description of external ids
    }
}
